export default "__VITE_ASSET__DU6iHWGI__"